

















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { getQueryString } from '@/Api/api_data';
import api_simulaion from '@/Api/api_simulaion';
import { delayedPromise } from '@/Utils/promise-utils';
import { DataLoad } from '@/Utils/decorator/data-load';
import Tools from '@/component/template/tools/tools';
import { profile } from '@/Utils/profile';
const ieslabDisableRules = profile.get('ieslabDisableRules') === 'true';

const DefaultEnvironmentalData = {
    tableData: {
        year: {
            CO2: [0.0, 0.0],
            氮化物: [0.0, 0.0],
            SO2: [0.0, 0.0],
            烟尘: [0.0, 0.0],
        },
        month: {
            CO2: [
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            ],
            氮化物: [
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            ],
            SO2: [
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            ],
            烟尘: [
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            ],
        },
    },
    totalCO2: 0,
    totalNOX: 0,
    totalSO2: 0,
    totalDist: 0,
    startYear: '1970',
};
/**
 * TableColumn
 */
interface TableColumn {
    /**
     * dataIndex
     */
    dataIndex: number | string;
    /**
     * key
     */
    key: string | number;
    /**
     * title
     */
    title?: string;
    /**
     * align
     */
    align?: string;
    /**
     * width
     */
    width?: number;
    /**
     * fixed
     */
    fixed?: string;
}
/**
 *
 */
@Component({})
export default class EnvironmentalProtection extends Vue {
    /** disabledFunction */
    disabledFunction = ieslabDisableRules;
    /** 是否显示年 */
    isShowYear = true;

    /** 是否展开 */
    isExpanded = false;
    /** */
    startYear = 0;
    /** */
    endYear = 0;

    /** */
    yearList = new Array<number>();

    /** */
    currentYearIndex = 0;

    /** */
    environmentalData: typeof DefaultEnvironmentalData = JSON.parse(JSON.stringify(DefaultEnvironmentalData));

    /** */
    signTime = 0;

    /**
     *获取表格列配置
     */
    get tableColumns(): TableColumn[] {
        const result = new Array<TableColumn>();
        result.push({
            dataIndex: 'pollutionType',
            key: 'pollutionType',
            title: '污染类型',
            align: 'center',
            width: 100,
            fixed: 'left',
        });
        this.yearList = [];
        this.startYear = Number(this.environmentalData.startYear);
        const startYear = this.startYear;
        const timeSpan = this.environmentalData.tableData.year.CO2.length;
        for (let i = 0; i < timeSpan; i++) {
            this.yearList.push(i + startYear);
        }
        if (this.isShowYear) {
            for (let i = 0; i < timeSpan; i++) {
                const width = timeSpan > 7 ? 200 : undefined;
                const column: TableColumn = {
                    dataIndex: startYear + i,
                    key: i,
                    title: `${startYear + i}年`,
                    align: 'center',
                    width: this.isExpanded ? width : undefined,
                };
                if (i === 0) {
                    column['scopedSlots'] = { title: 'startYearTitle' };
                    delete column.title;
                } else if (i === timeSpan - 1) {
                    column['scopedSlots'] = { title: 'endYearTitle' };
                    delete column.title;
                    this.endYear = startYear + i;
                } else if (!this.isExpanded) {
                    continue;
                }
                result.push(column);
            }
        } else {
            const monthList = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];
            for (let i = 0; i < 12; i++) {
                result.push({ dataIndex: i, key: monthList[i], title: monthList[i], align: 'center' });
            }
        }
        return result;
    }

    /**
     *
     */
    get yearTableData(): Array<Record<string, string | number>> {
        if (this.environmentalData.startYear === '1970') {
            return [];
        }
        const result = new Array<Record<string, string | number>>(4);
        const startYear = Number(this.environmentalData.startYear);
        const timeSpan = this.environmentalData.tableData.year.CO2.length;
        result[0] = { pollutionType: 'CO2', key: 'CO2' };
        result[1] = { pollutionType: 'SO2', key: 'SO2' };
        result[2] = { pollutionType: '氮化物', key: '氮化物' };
        result[3] = { pollutionType: '烟尘', key: '烟尘' };
        for (let i = 0; i < timeSpan; i++) {
            result[0][startYear + i] = this.environmentalData.tableData.year.CO2[i].toFixed(2);
            result[1][startYear + i] = this.environmentalData.tableData.year.SO2[i].toFixed(2);
            result[2][startYear + i] = this.environmentalData.tableData.year.氮化物[i].toFixed(2);
            result[3][startYear + i] = this.environmentalData.tableData.year.烟尘[i].toFixed(2);
        }
        return result;
    }

    /**
     *
     */
    monthTableData(yearIndex: number): Array<Record<string, string | number>> {
        if (this.environmentalData.startYear === '1970') {
            return [];
        }
        const result = new Array<Record<string, string | number>>(4);
        result[0] = { pollutionType: 'CO2', key: 'CO2' };
        result[1] = { pollutionType: 'SO2', key: 'SO2' };
        result[2] = { pollutionType: '氮化物', key: '氮化物' };
        result[3] = { pollutionType: '烟尘', key: '烟尘' };
        for (let i = 0; i < 12; i++) {
            result[0][i] = this.environmentalData.tableData.month.CO2[yearIndex][i].toFixed(2);
            result[1][i] = this.environmentalData.tableData.month.SO2[yearIndex][i].toFixed(2);
            result[2][i] = this.environmentalData.tableData.month.氮化物[yearIndex][i].toFixed(2);
            result[3][i] = this.environmentalData.tableData.month.烟尘[yearIndex][i].toFixed(2);
        }
        return result;
    }

    /**
     *获取 表格数据
     */
    get tableData(): Array<Record<string, string | number>> {
        if (this.isShowYear) {
            return this.yearTableData;
        } else {
            return this.monthTableData(this.currentYearIndex);
        }
    }

    /**
     *
     */
    get cardList(): Array<{ backgroundColor: string; icon: string; title: string; subtitle: string; backgroundImage: string }> {
        return [
            {
                backgroundColor: '#2058a5',
                icon: 'fire',
                title: this.environmentalData.totalCO2.toFixed(2),
                subtitle: '二氧化碳排放量',
                // eslint-disable-next-line no-undef
                backgroundImage: require('@/assets/sample/r01.png'),
            },
            {
                backgroundColor: '#4c92f2',
                icon: 'fire',
                title: this.environmentalData.totalSO2.toFixed(2),
                subtitle: '二氧化硫排放量',
                // eslint-disable-next-line no-undef
                backgroundImage: require('@/assets/sample/r02.png'),
            },
            {
                backgroundColor: '#20a0a5',
                icon: 'fire',
                title: this.environmentalData.totalNOX.toFixed(2),
                subtitle: '氮化物排放量',
                // eslint-disable-next-line no-undef
                backgroundImage: require('@/assets/sample/r03.png'),
            },
            {
                backgroundColor: '#f25c4c',
                icon: 'fire',
                title: this.environmentalData.totalDist.toFixed(2),
                subtitle: '烟尘排放量',
                // eslint-disable-next-line no-undef
                backgroundImage: require('@/assets/sample/r04.png'),
            },
        ];
    }

    /**
     *保存数据到暂存区以便计算
     */
    async saveDataToWorkingArea(): Promise<unknown> {
        return await api_simulaion.saveDataToclickhouse({
            simuid: this.$route.query.simu_id,
            planId: this.$store.getters.getCurrentPlanId,
            CMD_TYPE: 'environmentalEvaluation',
        });
    }

    /**
     *
     */
    get currentPlanId(): number {
        return this.$store.getters.getCurrentPlanId;
    }

    /**
     *单次获取计算结果
     */
    @Watch('currentPlanId')
    @DataLoad()
    async getEnvironmentalEvaluation(): Promise<void> {
        this.signTime = 0;
        const data = (await api_simulaion.getEnvironmentalEvaluation({
            simu_id: getQueryString()['simu_id'],
            planId: this.$store.getters.getCurrentPlanId,
            time: this.signTime,
        })) as { results: [{ data: typeof DefaultEnvironmentalData; time: number }?] };
        if (data.results[0] != null) {
            this.signTime = data.results[0].time;
            this.environmentalData = data.results[0].data;
        } else {
            this.environmentalData = DefaultEnvironmentalData;
        }
    }

    /**
     * 循环获取计算结果
     */
    async getEnvironmentalEvaluationCyclic(): Promise<void> {
        const data = (await api_simulaion.getEnvironmentalEvaluation({
            simu_id: getQueryString()['simu_id'],
            planId: this.$store.getters.getCurrentPlanId,
            time: this.signTime,
        })) as { results: [{ data: typeof DefaultEnvironmentalData; time: number }?] };
        if (data.results[0] == null) {
            await delayedPromise(3000);
            await this.getEnvironmentalEvaluationCyclic();
        } else {
            this.signTime = data.results[0].time;
            this.environmentalData = data.results[0].data;
        }
    }

    /**
     *
     */
    async exportToFile(): Promise<void> {
        //构建年份数据
        const yearSheetData: Array<Array<string | number>> = [[''], [''], [''], [''], ['']];
        const startYear = this.startYear;
        const timeSpan = this.environmentalData.tableData.year.CO2.length;
        yearSheetData[0][0] = '污染类型';
        yearSheetData[1][0] = 'CO2';
        yearSheetData[2][0] = 'SO2';
        yearSheetData[3][0] = '氮化物';
        yearSheetData[4][0] = '烟尘';
        yearSheetData[0] = yearSheetData[0].concat(new Array(timeSpan).fill('').map((item, index) => index + startYear)).concat('总计');
        yearSheetData[1] = yearSheetData[1].concat(this.environmentalData.tableData.year.CO2).concat(this.environmentalData.totalCO2);
        yearSheetData[2] = yearSheetData[2].concat(this.environmentalData.tableData.year.SO2).concat(this.environmentalData.totalSO2);
        yearSheetData[3] = yearSheetData[3].concat(this.environmentalData.tableData.year.氮化物).concat(this.environmentalData.totalNOX);
        yearSheetData[4] = yearSheetData[4].concat(this.environmentalData.tableData.year.烟尘.concat(this.environmentalData.totalDist));
        const sheetsData = [{ name: '总数据', data: yearSheetData }];
        //构建月份数据
        for (let i = 0; i < timeSpan; i++) {
            const monthSheetData: Array<Array<string | number>> = [[''], [''], [''], [''], ['']];
            monthSheetData[0][0] = '污染类型';
            monthSheetData[1][0] = 'CO2';
            monthSheetData[2][0] = 'SO2';
            monthSheetData[3][0] = '氮化物';
            monthSheetData[4][0] = '烟尘';
            monthSheetData[0] = monthSheetData[0].concat(['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']);
            monthSheetData[1] = monthSheetData[1].concat(this.environmentalData.tableData.month.CO2[i]);
            monthSheetData[2] = monthSheetData[2].concat(this.environmentalData.tableData.month.SO2[i]);
            monthSheetData[3] = monthSheetData[3].concat(this.environmentalData.tableData.month.氮化物[i]);
            monthSheetData[4] = monthSheetData[4].concat(this.environmentalData.tableData.month.烟尘[i]);
            sheetsData.push({ name: startYear + i + '年数据', data: monthSheetData });
        }
        await Tools.exportXlsxFile(this.$route.meta?.title, sheetsData);
    }

    /**
     *开始计算
     */
    async startCalculate(): Promise<void> {
        try {
            this.$notification.success({
                message: '正在计算',
                key: this.$options.name,
                duration: 0,
                description: '',
                //$createElement返回一个vNode,需要在vue.config.js里开启runtimeCompiler才可以使用,应用将会增加10kb
                icon: this.$createElement({ template: '<a-icon type="loading" style="color: #108ee9" />' }),
            });
            await this.saveDataToWorkingArea();
            await this.getEnvironmentalEvaluationCyclic();
            this.$notification.success({ message: '计算完成', key: this.$options.name, duration: 2.5, description: '' });
        } catch (e) {
            await this.$message.error({ content: '计算失败,错误信息:' + String(e), key: '环保评价', duration: 2.5 });
            throw new Error('计算失败,错误信息:' + String(e));
        }
    }

    /**
     *
     */
    async mounted(): Promise<void> {
        await this.getEnvironmentalEvaluation();
        this.disabledFunction = ieslabDisableRules;
    }
}
